export enum RegionType {
  LOCAL = "LOCAL",
  STATE = "STATE",
  NATIONAL = "NATIONAL",
  INTERNATIONAL = "INTERNATIONAL",
}
